import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { Button, Col } from "reactstrap";
import { useDispatch} from "react-redux";
import { resetPassword } from "../redux/actions/auth/auth.actions";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import OtpModel from "./OtpModel";
import { useTranslation } from "react-i18next";

const ForgotPassword = ({ setForgotFalg }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMsg, setError] = useState("");
  // const [userEmail, setUserEmail] = useState("");
  const [otpModal, setOTPModal] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string("Please fill in the field Thank You").email().required(),
  });
  const handleSubmit = (values) => {
    // setUserEmail(values.email);
    const resetData = {
      email: values.email,
    };
    dispatch(resetPassword(resetData)).then((data) => {
      setOTPModal(true);
      setError(data);
    });
  };

  const gobackFunc = () => {
    setForgotFalg(false);
    navigate("/login", { replace: true });
  };

  function clearError() {
    return errorMsg.state === "success" ? (
      <div className="mb-3 text-success text-center">{errorMsg.message}</div>
    ) : (
      <div className="mb-3 error-text text-center">{errorMsg.message}</div>
    );
  }
  return (
    <>
      <div className="mt-4 text-center">
        <div>
          <span
            style={{
              color: "black",
              fontWeight: "700",
              fontSize: "16px",
              marginLeft:"-12px"
            }}
          >
            {t('restorePassword')}
          </span>
        </div>
        <div className="mt-3 mb-3">
          <span className="font12 px-3">
            {t('restorePasswordText')}
          </span>
        </div>
      </div>
      <Formik
        initialValues={{ email: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, isValid, dirty }) => (
          <Form onSubmit={handleSubmit}>
            {errorMsg !== null ? clearError() : ""}

            <Col lg="12" md="12" sm="12" xs="12" className="px-3 mx-auto">
              <div className="position-relative" onClick={() => setError("")}>
                <label className="LabelForgot">{t('email')}</label>
                <MdEmail className="MdinfoForgot" color="black" size={20} />
                <input
                  name="email"
                  className="form-control input-btn email mx-auto"
                  placeholder={t("email")}
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="12" md="12" sm="12" xs="12">
              <div className="d-flex justify-content-center align-items-end gap-2 px-3 mt-4 mb-4">
                <div className="position-relative">
                  <BiChevronLeft className="forgotAiLeft" size={27} />
                  <button
                    className="backToLogin"
                    style={{ cursor: "grab" }}
                    onClick={() => {
                      gobackFunc();
                      setError("");
                    }}
                  >
                    {t('back')}
                  </button>
                </div>
                <Button
                  type="submit"
                  className="forgotSubmit"
                  disabled={!(dirty && isValid)}
                >
                  <b>{t('restorePassword')}</b>
                </Button>
              </div>
            </Col>
          </Form>
        )}
      </Formik>

      { otpModal && <OtpModel setOTPModal={() => setOTPModal(!otpModal)} otpModal={otpModal} setError={setError} forget={{forgetScreen:true}}/> }
      {/* { otpModal && <OtpModel setOTPModal={() => setOTPModal(!otpModal)} setOTPResponse={(e) => setOTPResponse(e)} otpModal={otpModal} userEmail/> } */}

    </>
  );
};
export default ForgotPassword;